import React, { FC } from 'react';
import './styles.scss';

interface IPageWrapper {
  bgType: 'image' | 'color';
  bgImageUrl?: string;
}

const PageWrapper: FC<IPageWrapper> = ({ bgType, bgImageUrl, children }) => {
  return (
    <main
      className={`hbh-main ${bgType === 'image' ? 'bg-image' : 'bg-color'}`}
      {...(bgType === 'image' && bgImageUrl
        ? { style: { background: `url("${bgImageUrl}") no-repeat center` } }
        : {})}
    >
      <section className='hbh-wrapper'>{children}</section>
    </main>
  );
};

export default PageWrapper;
